import { Component, EventEmitter, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import {
  get_project_details,
  update_project_and_create_new_folder,
  update_project_and_update_folder,
  update_project_and_update_folder_no_ic,
  update_project_and_create_new_folder_no_ic,
  update_ic_code,
  update_project_profile_details,
  update_folder,
  create_new_folder,
  update_ic_code_update_folder,
  update_ic_code_new_folder,
  get_project_photo,
  create_owned_entity,
  create_entity_attribute_ownership_interest,
  delete_middle_tier_entity,
} from './graphql/getProjectDetails';
import { MissingDataService } from '../../services/missing-data.service';
import { MatDrawer, MatSidenav } from '@angular/material/sidenav';
import { MatAccordion } from '@angular/material/expansion';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import {
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { TooltipPosition } from '@angular/material/tooltip';
import { Clipboard } from '@angular/cdk/clipboard';
import { EnvironmentService } from 'src/app/environment/environment.service';
import { PageTitleService } from 'src/app/services/page-title.service';
import { DataFormatService } from '../../services/data-format.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/auth/auth.service';

const GET_PROJECT_DETAILS = get_project_details;
const UPDATE_PROJECT_PROFILE_AND_UPDATE_FOLDER =
  update_project_and_update_folder;
const UPDATE_PROJECT_AND_CREATE_NEW_FOLDER =
  update_project_and_create_new_folder;

@Component({
    selector: 'app-deals-home',
    templateUrl: './deals-home.component.html',
    styleUrls: ['./deals-home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealsHomeComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild(MatDrawer) drawer: MatDrawer;
  @ViewChild(MatSidenav) missingDataNav: MatSidenav;

  public subsequences: any[];
  isEditMode: boolean = false;
  hasLoaded: boolean = false;
  sectionSelect: any = [];
  hasRequirements: boolean = false;
  requirementsData: any = [];
  photoUploadState = {
    uploading: false,
    success: false,
    errorMessage: '',
  };
  querySubscription: Subscription;
  projectid: any;
  project: any;
  sharepointLink: any;
  yDriveID: any;
  yDrivePath: any;
  creaLinkPath: any;
  attributeTypes: any;
  roles: any;
  permissions: any;
  hasICPermissions: boolean = false;
  hasDealNamePermissions: boolean = false;
  address: any;
  addressOneLine: string = '';
  projectProfile: any;
  sequences: any;
  deadSequence: any;
  deadStatus: any;
  closingStatus: string;
  actualDateClass: any;
  targetDateClass: any;
  dateTypes: any;
  setAsideTypes: any;
  loanTypes: any;
  loanFinancingTermType: any;
  statuses: any;
  pipelineProjects: any;
  taxCreditTypes: any;
  taxCreditDesignations: any;
  projectCreditStatuses: any;
  syndicationsStatuses: any;
  projectCredits:any[]
  projectMilestoneDates: any;
  forecastApprovalDateTypeID: any;
  applications: any;
  fundProjectStates:any[];
  placementGuidanceExpDateID: string;
  placementGuidanceIssuedDateID: string;
  responseToDevNeededID: string;
  pricingDetails: any;
  participants: any;
  participantsSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  participants$ = this.participantsSubject.asObservable();
  profileForm: any;
  updateDetails: boolean = false;
  positionRight: TooltipPosition = 'right';
  position = new FormControl(this.positionRight);
  warningChecked = false;
  midTierIds: any;
  middleTierEntities: any = [];
  midTierButtonLocked: boolean = false;
  sponsors: Array<any> = []

  constructor(
    private apollo: Apollo,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private clipboard: Clipboard,
    private missingData: MissingDataService,
    public dataFormat: DataFormatService,
    public env: EnvironmentService,
    public titleService: PageTitleService,
    private dialog: MatDialog,
    public auth: AuthService
  ) {}

  ngOnInit(): void {
    this.projectid = this.route.snapshot.paramMap.get('id');

    this.querySubscription = this.apollo
      .watchQuery<any>({
        query: GET_PROJECT_DETAILS,
        fetchPolicy: 'no-cache',
        variables: {
          projectid: this.projectid,
        },
      })
      .valueChanges.subscribe(({ data }) => {
        if(data) {
          this.hasLoaded = true;
          this.querySubscription.unsubscribe();
          this.project = data.project;
          this.midTierIds = {
            entity: data.owned_entity_type_by_name.id,
            owner: data.owner_type_by_name.id,
          };
          this.statuses = data.project.projectStatuses;

          for (let i = 0; i < this.statuses?.length; i++) {
            if (this.statuses[i].statusSequence.name === 'Closing') {
              this.closingStatus = this.statuses[i].status?.name ?? 'Unknown';
              break;
            }
          }
          if (this.project?.ownedEntity) {
            for (
              let i = 0;
              i < this.project.ownedEntity.ownershipInterests.length;
              i++
            ) {
              if (
                this.project.ownedEntity.ownershipInterests[i].ownerType.name ===
                'Middle-Tier'
              ) {
                this.middleTierEntities.push(
                  this.project.ownedEntity.ownershipInterests[i]
                );
              }
            }
          }

          this.pipelineProjects = data.project.pipelineProjects;
          this.projectCredits = data.project.projectCredits;
          this.sharepointLink = data.drive_path_by_type.path;
          this.yDriveID = data.y_drive.id;
          this.yDrivePath = data.y_drive.path;
          this.creaLinkPath = data.crea_link.path;
          this.attributeTypes = data.attribute_types;
          this.taxCreditTypes = data.taxCreditTypes;
          this.taxCreditDesignations = data.taxCreditDesignations;
          this.projectCreditStatuses = data.projectCreditStatuses;
          this.fundProjectStates = data.fund_project_states
          this.roles = data.roles.filter((role: any) => role.active === true);
          this.permissions = data.me;
          this.checkICPermissions();
          this.checkDealNamePermissions();
          this.setSections(this.permissions.addressPermissions._edit);
          this.address =
            data.project.properties[0].entity.entityAddresses &&
            data.project.properties[0].entity.entityAddresses.length > 0
              ? data.project.properties[0].entity.entityAddresses[0].address
              : null;
          this.formatAddress();
          this.sequences = [
            data.closingSequence,
            data.managingSequence,
            data.syndicationsSequence,
          ];
          this.syndicationsStatuses = data.syndicationsStatuses
          this.deadSequence = data.deadSequence;
          this.deadStatus = data.deadStatus;
          this.actualDateClass = data.actualDateClass;
          this.targetDateClass = data.targetDateClass;
          this.dateTypes = data.date_types;
          this.setAsideTypes = data.setAsideTypes;
          this.loanTypes = data.loanTypes;
          this.loanFinancingTermType = data.financingTermType;
          this.projectMilestoneDates = data.project.projectMilestoneDates;
          this.forecastApprovalDateTypeID = data.date_type.id;
          this.applications = data.project.applications;
          this.placementGuidanceExpDateID =
            data.placement_guidance_expiration_date.id;
          this.placementGuidanceIssuedDateID =
            data.placement_guidance_issued_date.id;
          this.responseToDevNeededID = data.response_to_developer_needed.id;
          this.pricingDetails = data.project.projectPricingDetail;
          this.participants = data.project.participants;
          this.setSponsors();
          this.participantsSubject.next(this.participants);
          this.setProjectProfile();
          this.titleService.setTitle(data.project.name);
          this.subsequences = data.subsequences;
        }
      });
  }

  ngAfterViewChecked() {
    if (this.missingDataNav && !this.warningChecked) {
      // this.checkMissingInitialDates();
    }
  }

  toggleAll(expanded: boolean) {
    this.sectionSelect.map((section: any) =>
      !!section.subSections
        ? section.subSections.map(
            (subSection: any) => (subSection.expanded = expanded)
          )
        : (section.expanded = expanded)
    );
  }

  setSponsors(){
    if(this.project.participants){
      for(let i = 0; i < this.project.participants.length; i ++){
        if(this.project.participants[i].role.roleType.name == 'Deal Sponsor'){
          let found = this.sponsors.find((sponsor) => sponsor.key == this.project.participants[i].role.name)
          if(found){
            found.value.push(this.project.participants[i].sponsor)
          } else {
            this.sponsors.push({key: this.project.participants[i].role.name, value: [this.project.participants[i].sponsor]})
          }
        }
      }
    }
  }

  goToLink(link: string) {
    window.open(link, '_blank');
  }
  clickExternalLink(event: MouseEvent) {
    event.stopPropagation();
  }
  checkICPermissions() {
    for (let i = 0; i < this.permissions.groups.length; i++) {
      if (
        this.permissions.groups[i].name === 'Information Technology' ||
        this.permissions.groups[i].name === 'Administration'
      ) {
        this.hasICPermissions = true;
        break;
      }
    }
  }

  checkDealNamePermissions() {
    for (let i = 0; i < this.permissions.groupsFlattened.length; i++) {
      if (
        this.permissions.groupsFlattened[i].name === 'CREAWeb Developers' ||
        this.permissions.groupsFlattened[i].name === 'Deal Name Editors'
      ) {
        this.hasDealNamePermissions = true;
        break;
      }
    }
  }

  idForSection(section: any) {
    if (section?.name) {
      return section.name.replace(' ', '_').toLowerCase();
    }
    return '';
  }
  setSections(addressPermissions: boolean) {
    this.sectionSelect = [
      { name: 'Statuses', class: 'col-md-12', expanded: true },
      { name: 'Participants', class: 'col-md-12', expanded: true },
      { name: 'Tax Credits', class: 'col-md-12', expanded: true },
      { name: 'Deal Information', class: 'col-md-12', expanded: true },
    ];

    if (addressPermissions) {
      this.sectionSelect.push({
        name: 'Combined',
        subSections: [
          { name: 'Address', class: 'col-md-6', expanded: true },
          { name: 'Deal Dates', class: 'col-md-6', expanded: true },
        ],
      });
    } else {
      this.sectionSelect.push({
        name: 'Deal Dates',
        class: 'col-md-12',
        expanded: true,
      });
    }

    this.sectionSelect.push(
      { name: 'Credit Outlets', class: 'col-md-12', expanded: true },
      { name: 'Pricing', class: 'col-md-12', expanded: true },
      { name: 'Notes', class: 'col-md-12', expanded: true },
      { name: 'Loans', class: 'col-md-12', expanded: true },
      { name: 'ESG & Supportive Services', class: 'col-md-12', expanded: true },
      { name: 'Tax Credit Applications', class: 'col-md-12', expanded: true },
      { name: 'Dispositions', class: 'col-md-12', expanded: true },
      { name: 'Construction', class: 'col-md-12', expanded: true },
      { name: 'Asset Management', class: 'col-md-12', expanded: true },
      { name: 'LT Model Exports', class: 'col-md-12', expanded: true }
    );
    this.sectionSelect = this.sectionSelect.map((section: any) => ({
      ...section,
      id: this.idForSection(section),
      subSections: section.subSections?.map((subSection: any) => ({
        ...subSection,
        id: this.idForSection(subSection),
      })),
    }));
  }

  passAddress(address: any) {
    this.address = address;
    this.formatAddress();
  }

  passParticipants(participants: any) {
    this.participants = participants;
    this.participantsSubject.next(this.participants);
  }

  formatAddress() {
    let formatted = '';
    if (this.address) {
      if (this.address.address1) {
        formatted = this.address.address1;
      }

      if (this.address.address2) {
        formatted += ' ' + this.address.address2;
      }

      if (this.address.zipCode) {
        if (this.address.address1) {
          formatted += ' ';
        }

        formatted +=
          this.address.zipCode.city +
          ', ' +
          this.address.zipCode.state.abbreviation +
          ' ' +
          this.address.zipCode.zipcode;

        if (this.address.zipCode.county) {
          formatted += ', ' + this.address.zipCode.county.name;

          if (
            this.address.zipCode.county.metroStatAreaCounties.length > 0 &&
            this.address.zipCode.county.metroStatAreaCounties[0].metroStatArea
          ) {
            formatted +=
              ', MSA: ' +
              this.address.zipCode.county.metroStatAreaCounties[0].metroStatArea
                .name;
          }
        }
      }
    }
    this.addressOneLine = formatted;
  }

  copyToClipboard() {
    this.clipboard.copy(
      encodeURI('file://///' + this.yDrivePath + this.projectProfile.path)
    );
    const config = new MatSnackBarConfig();
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = 2000;
    this._snackBar.open('Deal Path Copied Successfully', 'Ok', config);
  }
  setProjectProfile(newData?: any) {
    if (newData === undefined) {
      this.projectProfile = {
        name: this.project.name,
        entityid: this.project.ownedEntity ? this.project.ownedEntity.id : null,
        entity: this.project.ownedEntity ? this.project.ownedEntity.name : null,
        mid_tier: this.project.mid_tier ? this.project.mid_tier : [],
        ein: this.project.ein ? this.project.ein : '',
        ic_code: this.project.ic_code ? this.project.ic_code : '',
        pathid: this.project.projectDriveFolder
          ? this.project.projectDriveFolder.id
          : null,
        path: this.project.projectDriveFolder
          ? this.project.projectDriveFolder.path
          : '',
        image:
          this.project.projectPhoto && this.project.projectPhoto.image
            ? 'data:' +
              this.project.projectPhoto.filetype +
              ';base64,' +
              this.project.projectPhoto.image
            : '',
      };
    } else {
      if (newData.hasOwnProperty('name')) {
        this.projectProfile.name = newData.name;
      }

      if (newData.hasOwnProperty('ein')) {
        this.projectProfile.ein = newData.ein;
      }

      if (newData.hasOwnProperty('ic_code')) {
        this.projectProfile.ic_code = newData.ic_code;
      }

      if (newData.hasOwnProperty('entity')) {
        this.projectProfile.entity = newData.entity;
      }

      if (newData.hasOwnProperty('path')) {
        this.projectProfile.path = newData.path;
      }

      if (newData.hasOwnProperty('pathid')) {
        this.projectProfile.pathid = newData.pathid;
      }
    }

    this.profileForm = new FormGroup({
      name: new FormControl(this.projectProfile.name, Validators.required),
      entity: new FormControl(this.projectProfile.entity, Validators.required),
      mid_tier: new FormControl(this.projectProfile.mid_tier),
      ein: new FormControl(this.projectProfile.ein, Validators.maxLength(10)),
      ic_code: new FormControl(
        this.projectProfile.ic_code,
        Validators.maxLength(8)
      ),
      path: new FormControl(this.projectProfile.path),
    });
  }

  changeEditMode() {
    if (this.isEditMode && this.updateDetails) {
      this.updateDetails = false;
      if (
        this.hasICPermissions &&
        this.permissions.projectDriveFolderPermissions._edit &&
        this.permissions.projectDetailPermissions._edit
      ) {
        if (this.projectProfile.pathid) {
          this.apollo
            .mutate({
              mutation: UPDATE_PROJECT_PROFILE_AND_UPDATE_FOLDER,
              variables: {
                id: this.project.id,
                projectInput: {
                  name: this.profileForm.get('name').value,
                  ein: this.profileForm.get('ein').value,
                },
                icCode: this.profileForm.get('ic_code').value,
                entityID: this.projectProfile.entityid,
                entityName: this.profileForm.get('entity').value,
                pathID: this.projectProfile.pathid,
                path: this.profileForm.get('path').value,
              },
            })
            .subscribe(({ data }) => {
              let updatedInfo: any = data;
              if (updatedInfo) {
                this.openSnackBar();
                let formatted = {
                  name: updatedInfo.updateProjectProfile.name,
                  ein: updatedInfo.updateProjectProfile.ein,
                  ic_code: updatedInfo.updateProjectICCode.ic_code,
                  entity: updatedInfo.updateProjectEntity.name,
                  path: updatedInfo.updateDealFolder.path,
                  pathid: updatedInfo.updateDealFolder.id,
                };
                if (this.projectProfile.entityid == null) {
                  this.projectProfile.entityid =
                    updatedInfo.updateProjectEntity.id;
                }
                this.setProjectProfile(formatted);
              }
            });
        } else {
          this.apollo
            .mutate({
              mutation: UPDATE_PROJECT_AND_CREATE_NEW_FOLDER,
              variables: {
                id: this.project.id,
                projectInput: {
                  name: this.profileForm.get('name').value,
                  ein: this.profileForm.get('ein').value,
                },
                icCode: this.profileForm.get('ic_code').value,
                entityID: this.projectProfile.entityid,
                entityName: this.profileForm.get('entity').value,
                path: this.profileForm.get('path').value,
                driveID: this.yDriveID,
              },
            })
            .subscribe(({ data }) => {
              let updatedInfo: any = data;
              if (updatedInfo) {
                this.openSnackBar();
                let formatted = {
                  name: updatedInfo.updateProjectProfile.name,
                  ein: updatedInfo.updateProjectProfile.ein,
                  ic_code: updatedInfo.updateProjectICCode.ic_code,
                  entity: updatedInfo.updateProjectEntity.name,
                  path: updatedInfo.updateDealFolder.path,
                  pathid: updatedInfo.updateDealFolder.id,
                };
                if (this.projectProfile.entityid == null) {
                  this.projectProfile.entityid =
                    updatedInfo.updateProjectEntity.id;
                }
                this.setProjectProfile(formatted);
              }
            });
        }
      } else if (
        !this.hasICPermissions &&
        this.permissions.projectDriveFolderPermissions._edit &&
        this.permissions.projectDetailPermissions._edit
      ) {
        if (this.projectProfile.pathid) {
          this.apollo
            .mutate({
              mutation: update_project_and_update_folder_no_ic,
              variables: {
                id: this.project.id,
                projectInput: {
                  name: this.profileForm.get('name').value,
                  ein: this.profileForm.get('ein').value,
                },
                entityID: this.projectProfile.entityid,
                entityName: this.profileForm.get('entity').value,
                pathID: this.projectProfile.pathid,
                path: this.profileForm.get('path').value,
              },
            })
            .subscribe(({ data }) => {
              let updatedInfo: any = data;
              if (updatedInfo) {
                this.openSnackBar();
                let formatted = {
                  name: updatedInfo.updateProjectProfile.name,
                  ein: updatedInfo.updateProjectProfile.ein,
                  entity: updatedInfo.updateProjectEntity.name,
                  path: updatedInfo.updateDealFolder.path,
                  pathid: updatedInfo.updateDealFolder.id,
                };
                this.setProjectProfile(formatted);
              }
            });
        } else {
          this.apollo
            .mutate({
              mutation: update_project_and_create_new_folder_no_ic,
              variables: {
                id: this.project.id,
                projectInput: {
                  name: this.profileForm.get('name').value,
                  ein: this.profileForm.get('ein').value,
                },
                entityID: this.projectProfile.entityid,
                entityName: this.profileForm.get('entity').value,
                path: this.profileForm.get('path').value,
                driveID: this.yDriveID,
              },
            })
            .subscribe(({ data }) => {
              let updatedInfo: any = data;
              if (updatedInfo) {
                this.openSnackBar();
                let formatted = {
                  name: updatedInfo.updateProjectProfile.name,
                  ein: updatedInfo.updateProjectProfile.ein,
                  entity: updatedInfo.updateProjectEntity.name,
                  path: updatedInfo.updateDealFolder.path,
                  pathid: updatedInfo.updateDealFolder.id,
                };
                this.setProjectProfile(formatted);
              }
            });
        }
      } else if (
        this.hasICPermissions &&
        !this.permissions.projectDriveFolderPermissions._edit &&
        !this.permissions.projectDetailPermissions._edit
      ) {
        this.apollo
          .mutate({
            mutation: update_ic_code,
            variables: {
              id: this.project.id,
              icCode: this.profileForm.get('ic_code').value,
            },
          })
          .subscribe(({ data }) => {
            let updatedInfo: any = data;
            if (updatedInfo) {
              this.openSnackBar();
              let formatted = {
                ic_code: updatedInfo.updateProjectICCode.ic_code,
              };
              this.setProjectProfile(formatted);
            }
          });
      } else if (
        !this.hasICPermissions &&
        !this.permissions.projectDriveFolderPermissions._edit &&
        this.permissions.projectDetailPermissions._edit
      ) {
        this.apollo
          .mutate({
            mutation: update_project_profile_details,
            variables: {
              id: this.project.id,
              projectInput: {
                name: this.profileForm.get('name').value,
                ein: this.profileForm.get('ein').value,
              },
              entityID: this.projectProfile.entityid,
              entityName: this.profileForm.get('entity').value,
            },
          })
          .subscribe(({ data }) => {
            let updatedInfo: any = data;
            if (updatedInfo) {
              this.openSnackBar();
              let formatted = {
                name: updatedInfo.updateProjectProfile.name,
                ein: updatedInfo.updateProjectProfile.ein,
                entity: updatedInfo.updateProjectEntity.name,
              };
              this.setProjectProfile(formatted);
            }
          });
      } else if (
        !this.hasICPermissions &&
        this.permissions.projectDriveFolderPermissions._edit &&
        !this.permissions.projectDetailPermissions._edit
      ) {
        if (this.projectProfile.pathid) {
          this.apollo
            .mutate({
              mutation: update_folder,
              variables: {
                pathID: this.projectProfile.pathid,
                path: this.profileForm.get('path').value,
              },
            })
            .subscribe(({ data }) => {
              let updatedInfo: any = data;
              if (updatedInfo) {
                this.openSnackBar();
                let formatted = {
                  path: updatedInfo.updateDealFolder.path,
                  pathid: updatedInfo.updateDealFolder.id,
                };
                this.setProjectProfile(formatted);
              }
            });
        } else {
          this.apollo
            .mutate({
              mutation: create_new_folder,
              variables: {
                id: this.project.id,
                path: this.profileForm.get('path').value,
                driveID: this.yDriveID,
              },
            })
            .subscribe(({ data }) => {
              let updatedInfo: any = data;
              if (updatedInfo) {
                this.openSnackBar();
                let formatted = {
                  path: updatedInfo.updateDealFolder.path,
                  pathid: updatedInfo.updateDealFolder.id,
                };
                this.setProjectProfile(formatted);
              }
            });
        }
      } else if (
        this.hasICPermissions &&
        this.permissions.projectDriveFolderPermissions._edit &&
        !this.permissions.projectDetailPermissions._edit
      ) {
        if (this.projectProfile.pathid) {
          this.apollo
            .mutate({
              mutation: update_ic_code_update_folder,
              variables: {
                id: this.project.id,
                icCode: this.profileForm.get('ic_code').value,
                pathID: this.projectProfile.pathid,
                path: this.profileForm.get('path').value,
              },
            })
            .subscribe(({ data }) => {
              let updatedInfo: any = data;
              if (updatedInfo) {
                this.openSnackBar();
                let formatted = {
                  ic_code: updatedInfo.updateProjectICCode.ic_code,
                  path: updatedInfo.updateDealFolder.path,
                  pathid: updatedInfo.updateDealFolder.id,
                };
                this.setProjectProfile(formatted);
              }
            });
        } else {
          this.apollo
            .mutate({
              mutation: update_ic_code_new_folder,
              variables: {
                id: this.project.id,
                icCode: this.profileForm.get('ic_code').value,
                path: this.profileForm.get('path').value,
                driveID: this.yDriveID,
              },
            })
            .subscribe(({ data }) => {
              let updatedInfo: any = data;
              if (updatedInfo) {
                this.openSnackBar();
                let formatted = {
                  ic_code: updatedInfo.updateProjectICCode.ic_code,
                  path: updatedInfo.updateDealFolder.path,
                  pathid: updatedInfo.updateDealFolder.id,
                };
                this.setProjectProfile(formatted);
              }
            });
        }
      }
    }
    this.isEditMode = !this.isEditMode;
  }

  addMidTierTag() {
    if (this.midTierButtonLocked) {
      return;
    }
    this.midTierButtonLocked = true;
    if (
      this.profileForm.value.mid_tier.length == 0 ||
      (this.projectProfile.entityid == null &&
        this.project.ownedEntity == null &&
        this.project.ownedEntity.id == null)
    ) {
      this.midTierButtonLocked = false;
      return;
    }
    this.apollo
      .mutate({
        mutation: create_owned_entity,
        variables: {
          name: this.profileForm.value.mid_tier,
        },
      })
      .subscribe(({ data }) => {
        let response: any = data;
        this.apollo
          .mutate({
            mutation: create_entity_attribute_ownership_interest,
            variables: {
              owned_entity_id: response.createOwnedEntity.id,
              operating_entity_id: this.project.ownedEntity
                ? this.project.ownedEntity.id
                : this.projectProfile.entityid,
              owner_type_id: this.midTierIds.owner,
              owned_entity_type_id: this.midTierIds.entity,
            },
          })
          .subscribe(({ data }) => {
            let createData: any = data;
            this.middleTierEntities.push({
              ownedEntityOwner: {
                id: createData.createOwnedEntityAttribute.owned_entity_id,
                name: this.profileForm.value.mid_tier,
              },
              id: createData.createOwnershipInterest.id,
            });
            this.profileForm.controls.mid_tier.reset();
            this.midTierButtonLocked = false;
          });
      });
  }

  removeMidTierTag(entity: any) {
    this.apollo
      .mutate({
        mutation: delete_middle_tier_entity,
        variables: {
          owned_entity_id: entity.ownedEntityOwner.id,
          ownership_interest_id: entity.id,
        },
      })
      .subscribe(({ data }) => {
        for (let i = 0; i < this.middleTierEntities.length; i++) {
          if (
            this.middleTierEntities[i].ownedEntityOwner.id ==
            entity.ownedEntityOwner.id
          ) {
            this.middleTierEntities.splice(i, 1);
          }
        }
      });
  }

  openSnackBar() {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-success'];
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = 3000;
    this._snackBar.open('Data saved successfully.', 'Ok', config);
  }

  checkFormError(): boolean {
    let error = false;
    Object.keys(this.profileForm.controls).forEach((key) => {
      const controlErrors: ValidationErrors = this.profileForm.get(key).errors;
      if (controlErrors != null) {
        error = true;
      }
    });
    return error;
  }

  handleMissingRequirements(isMissingData: boolean) {
    this.hasRequirements = isMissingData;
    this.requirementsData = this.missingData.getData();

    this.hasRequirements && this.requirementsData !== null
      ? this.missingDataNav.open()
      : this.missingDataNav.close();
  }

  updateProjectStatusFromApp(data: any) {
    this.statuses = data.statuses;
    this.pipelineProjects = data.pipelines;
  }

  changeApplications(data: any) {
    this.applications = data;
  }

  checkMissingInitialDates() {
    if (this.statuses && this.statuses.length > 0) {
      for (let i = 0; i < this.statuses.length; i++) {
        if (this.statuses[i].statusSequence.name === 'Closing') {
          let activeIndex = null;
          let signedLOIIndex = null;
          for (
            let j = 0;
            j < this.statuses[i].statusSequence.status_sequence_details.length;
            j++
          ) {
            if (
              this.statuses[i].status &&
              this.statuses[i].status.name ===
                this.statuses[i].statusSequence.status_sequence_details[j]
                  .status.name
            ) {
              activeIndex =
                this.statuses[i].statusSequence.status_sequence_details[j]
                  .index;
            }
            if (
              this.statuses[i].statusSequence.status_sequence_details[j].status
                .name === 'Signed LOI'
            ) {
              signedLOIIndex =
                this.statuses[i].statusSequence.status_sequence_details[j]
                  .index;
            }
          }

          if (activeIndex >= signedLOIIndex) {
            let hasInitScreening = false;
            let hasInitCapital = false;
            if (this.pipelineProjects && this.pipelineProjects.length > 0) {
              for (let j = 0; j < this.pipelineProjects.length; j++) {
                if (this.pipelineProjects[j].pipeline.name === 'Closing') {
                  if (
                    this.pipelineProjects[j].pipelineProjectDates &&
                    this.pipelineProjects[j].pipelineProjectDates.length > 0
                  ) {
                    for (
                      let k = 0;
                      k < this.pipelineProjects[j].pipelineProjectDates.length;
                      k++
                    ) {
                      if (
                        this.pipelineProjects[j].pipelineProjectDates[k]
                          .pipelineMilestone.milestone.name ===
                          'Screening Committee' &&
                        this.pipelineProjects[j].pipelineProjectDates[k]
                          .initial_target
                      ) {
                        hasInitScreening = true;
                      }

                      if (
                        this.pipelineProjects[j].pipelineProjectDates[k]
                          .pipelineMilestone.milestone.name ===
                          'Capital Committee' &&
                        this.pipelineProjects[j].pipelineProjectDates[k]
                          .initial_target
                      ) {
                        hasInitCapital = true;
                      }
                    }
                  }
                }
              }
            }
            let requirements = [];
            if (!hasInitScreening) {
              requirements.push({
                field: 'Initial Screening Committee Completed Date',
                subsection: null,
              });
            }
            if (!hasInitCapital) {
              requirements.push({
                field: 'Initial Capital Committee Approved Date',
                subsection: null,
              });
            }
            if (requirements && requirements.length > 0) {
              this.missingData.setDataManually([
                {
                  type: 'Statuses',
                  value: {
                    anchor: 'statuses',
                    requirements: requirements,
                  },
                },
              ]);
              this.handleMissingRequirements(true);
            } else {
              this.missingData.setDataManually(null);
              this.handleMissingRequirements(false);
            }
          }
        }
      }
    }
    this.warningChecked = true;
  }

  // deleteDealConfirmation(){
  //   const ref: MatDialogRef<DeleteDealConfirmationComponent> = this.dialog.open(
  //     DeleteDealConfirmationComponent,
  //     {
  //       data: {
  //         deal: this.project,
  //       },
  //       backdropClass: 'confirmDialogComponent',
  //       hasBackdrop: true,
  //     });
  //   ref.afterClosed().subscribe((data) => {
  //     if(data.clicked === 'Ok'){
  //       this.apollo
  //         .mutate({
  //           mutation: delete_deal,
  //           variables: {
  //             id: this.project.id,
  //           },
  //         })
  //         .subscribe(
  //           ({ data }) => {
  //             window.location.href = this.env.jupiter_url + '/projects';
  //           }
  //         );
  //     }
  //   });
  // }

  scrollToSection(id: string) {
    // @ts-ignore
    document.getElementById(id.toLowerCase()).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  ngOnDestroy() {
    this.querySubscription.unsubscribe();
    this.titleService.setTitle('');
  }
  uploadPhoto(files: FileList) {
    let globalId = btoa(JSON.stringify(['Project', this.project.id]));
    this.photoUploadState.uploading = true;
    this.photoUploadState.errorMessage = '';
    for (let i = 0; i < files.length; i++) {
      let data = new FormData();
      data.append('image', files[i]);
      fetch(this.env.api_url + '/photo/' + globalId, {
        method: 'POST',
        body: data,
        headers: {
          Authorization: this.auth.getToken(),
        },
      })
        .then((response) => {
          if (response.status === 200) {
            return Promise.resolve(response);
          } else {
            return Promise.reject(response);
          }
        })
        .then((response) => {
          let sub = this.apollo
            .watchQuery({
              query: get_project_photo,
              variables: {
                projectId: this.projectid,
              },
              fetchPolicy: 'network-only',
            })
            .valueChanges.subscribe((response: any) => {
              let { data } = response;
              if (
                data?.hasOwnProperty('project') &&
                data?.project?.projectPhoto?.image
              ) {
                this.projectProfile.image =
                  'data:' +
                  data.project.projectPhoto.filetype +
                  ';base64,' +
                  data.project.projectPhoto.image;
                this.project.projectPhoto = data.project.projectPhoto;
              }
              sub && sub.unsubscribe();
            });

          this.photoUploadState.uploading = false;
          this.photoUploadState.success = true;
        })
        .catch((response) => {
          this.photoUploadState.uploading = false;
          this.photoUploadState.errorMessage =
            'Error uploading file. Please try again later or contact support if the problem continues.';
        });
    }
  }
}
